<template>
  <div>
    <!-- Select Type Input -->
    <select
      v-if="type === 'select'"
      :data-w-input="dataWInput"
      v-bind="$attrs"
      :class="`${staticClass}${isValid ? ' is-valid' : ''}${isInvalid ? ' is-invalid' : ''}`"
      :value="value"
      v-on="listenerSelect"
    >
      <slot></slot>
    </select>

    <!-- Textarea Type Input -->
    <textarea
      v-else-if="type === 'textarea'"
      :data-w-input="dataWInput"
      v-bind="$attrs"
      :class="`${staticClass}${isValid ? ' is-valid' : ''}${isInvalid ? ' is-invalid' : ''}`"
      v-on="listeners"
    >
      {{ value || '' }}
    </textarea>

    <!-- Repeatable Type Input -->
    <repeatable-input
      v-else-if="type === 'repeatable'"
      v-bind="$attrs"
      :value="value"
      :proto="generateProto(inputs)"
      :stacked="stacked"
      :striped="striped"
      v-on="listeners"
      >
      <template v-slot:default="{ row }">
        <div v-for="(input, slug) in inputs">
          <label v-if="stacked && input.label">{{input.label}}</label>
          <master-input
            :data-w-input="dataWInput"
            :key="slug"
            :type="input.type"
            v-model="row[slug]"
            class="form-control"
            :placeholder="input.label"
            :inputs="input.inputs"
            :proto="generateProto(input.inputs)"
            :stacked="input.stacked"
            :striped="input.striped"
            :lead-table-columns="leadTableColumns"
            :is-invalid="isInvalid"
          >
          <option
            v-if="input.options"
            v-for="(optionConfig, option) in input.options"
            :value="option"
          >
            {{option}}
          </option>
        </master-input>
          <br v-if="stacked">
        </div>
      </template>
    </repeatable-input>

    <!-- Static Values Input -->
    <static-values
      v-else-if="type === 'static-values'"
      v-bind="$attrs"
      :value="value"
      v-on="listeners"
      :lead-table-columns="leadTableColumns"
    />

    <!-- Column Key Map -->
    <column-key-map
      v-else-if="type === 'column-key-map'"
      v-bind="$attrs"
      :value="value"
      v-on="listeners"
      :lead-table-columns="leadTableColumns"
    />

    <!-- Logic -->
    <logic-fields
      v-else-if="type === 'logic-fields'"
      v-bind="$attrs"
      :value="value"
      v-on="listeners"
      :lead-table-columns="leadTableColumns"
    />

    <!-- Catch all Type Input (email, text, url, etc) -->
    <input
      v-else
      :data-w-input="dataWInput"
      :type="type"
      v-bind="$attrs"
      :class="`${staticClass}${isValid ? ' is-valid' : ''}${isInvalid ? ' is-invalid' : ''}`"
      :value="value"
      data-form-type="other"
      v-on="listeners"
    >
  </div>
</template>
<script>
  export default{
    name: 'MasterInput',
    inheritAttrs: false,
    data(){
      return {
        staticClass: ''
      }
    },
    props:{
      type: String,
      value: {},
      //for repeatable
      inputs: Object,
      proto:{},
      striped: {type: Boolean, default: false},
      stacked: {type: Boolean, default: false},
      isValid: {type: Boolean, default: false},
      isInvalid: {type: Boolean, default: false},
      dataWInput: {type: String, default: ''},

      // for static values
      leadTableColumns: {type: Array, default: ()=>{
          return []
        }
      }
    },
    computed:{
      /**
       * Copied from official vue docs
       * https://vuejs.org/v2/guide/components-custom-events.html#Binding-Native-Events-to-Components
       */
      listeners(){
        const vm = this

        return Object.assign({},
          this.$listeners,
          {
            // This ensures that the component works with v-model
            input: function (event) {
              vm.$dispatch('input', event.target ? event.target.value : event)
            },
            blur: function (event) {
              vm.$dispatch('blur', event.target ? event.target.value : event)
            }
          }
        )
      },
      listenerSelect(){
        return Object.assign({}, this.listeners, {
          change: function(event){
            event.target.blur()
          }
        })
      }
    },
    mounted(){
      this.staticClass = this.$el.classList.toString()
      this.$el.setAttribute('class', '')
    },
    methods:{
      generateProto(inputs){
        if(!inputs) return null
        const proto = {}
        Object.keys(inputs).forEach( (key)=>{
          return proto[key] = inputs[key].default_value ? inputs[key].default_value : ''
        })
        return [proto]
      }
    }
  }
</script>

<style lang="scss" scoped>

  .is-valid,
  .is-invalid {
    background-position: calc(100% - .5rem) calc(.4em + .1875rem);
  }

</style>
